// project imports
import { alertClasses, boxClasses, cardHeaderClasses, outlinedInputClasses } from '@mui/material';
import './DefaultColors';
import { timelineConnectorClasses, timelineOppositeContentClasses } from '@mui/lab';

const components = (theme) => {
  return {
    MuiScopedCssBaseline: {
      styleOverrides: {
        root: {
          backgroundColor: 'transparent',
          '*': {
            boxSizing: 'border-box',
          },
          a: {
            textDecoration: 'none',
          },
          '.svg-inline--fa': {
            // commented code interferes with overrides fontawesome sizing due to specificity
            // fontSize: '1rem',
            // width: '1em',
            transition: theme.transitions.create()
          },
          '.ql-container.ql-snow, .ql-toolbar.ql-snow': {
            border: '0 !important',
            borderRadius: '7px',
          },
          '.ql-editor, .ql-snow *': {
            fontFamiy: 'inherit !important',
          },
          hr: {
            height: '1px',
            border: 0,
            borderTop: `1px solid ${theme.palette.divider}`,
          },
          '.border-none': {
            border: '0px',
            td: {
              border: '0px',
            },
          },
          '.btn-xs': {
            minWidth: '30px !important',
            width: '30px',
            height: '30px',
            borderRadius: '6px !important',
            padding: '0px !important',
          },
          '.hover-text-primary:hover .text-hover': {
            color: theme.palette.primary.main,
          },
          '.hoverCard:hover': {
            scale: '1.01',
            transition: ' 0.1s ease-in',
          },
          '.signup-bg': {
            position: 'absolute',
            top: 0,
            right: 0,
            height: '100%',
          },
          [`.${boxClasses.root}`]: {
            borderRadius: theme.shape.borderRadius,
          },
          [`.${cardHeaderClasses.action}`]: {
            alignSelf: 'center !important',
          },
          '.emoji-picker-react .emoji-scroll-wrapper': {
            overflowX: 'hidden',
          },
          '.scrollbar-container': {
            borderRight: '0 !important',
          },
          [`.theme-timeline .${timelineOppositeContentClasses.root}`]: {
            minWidth: '90px',
          },
          [`.${alertClasses.root} .${alertClasses.icon}`]: {
            color: 'inherit!important',
          },
          [`.${timelineConnectorClasses.root}`]: {
            width: '1px !important',
          },
          ' .simplebar-scrollbar:before': {
            background: `${theme.palette.grey[300]} !important`,
          },
          '.cursor-pointer': {
            cursor: 'pointer',
          },
          '@keyframes marquee': {
            '0%': {
              transform: 'translate3d(0,0,0)',
            },
            '100% ': {
              transform: 'translate3d(-2086px,0,0)',
            },
          },
          '@keyframes marquee2': {
            '0%': {
              transform: 'translate3d(-2086px,0,0)',
            },
            '100% ': {
              transform: 'translate3d(0,0,0)',
            },
          },
          '@keyframes gradient': {
            '0%': {
              backgroundPosition: '0% 50%',
            },
            '50%': {
              backgroundPosition: ' 100% 50%',
            },
            '100% ': {
              backgroundPosition: ' 0% 50%',
            },
          },
          '.rounded-bars .apexcharts-bar-series.apexcharts-plot-series .apexcharts-series path': {
            clipPath: 'inset(0 0 5% 0 round 20px)',
          },
          '.animted-img-2': {
            position: 'absolute',
            zIndex: 9,
            top: '33%',
            right: '10%',
            animation: 'mover 5s infinite alternate',
          },
          '@keyframes mover': {
            '0%': {
              transform: 'translateY(0)',
            },
            '100% ': {
              transform: 'translateY(-10px)',
            },
          },
        },
      }
    },
    MuiAccordion: {
      styleOverrides: {
        root: {
          ':before': {
            backgroundColor: theme.palette.grey[100],
          },
        },
      },
    },
    MuiAccordionSummary: {
      styleOverrides: {
        content: {
          '&.Mui-expanded': {
            margin: theme.spacing(1.5, 0)
          }
        }
      }
    },
    MuiAlert: {
      styleOverrides: {
        filledSuccess: {
          color: 'white',
        },
        filledInfo: {
          color: 'white',
        },
        filledError: {
          color: 'white',
        },
        filledWarning: {
          color: 'white',
        },
        standardSuccess: {
          backgroundColor: theme.palette.success[50] || theme.palette.success.light,
          color: theme.palette.success.main,
        },
        standardError: {
          backgroundColor: theme.palette.error[50] || theme.palette.error.light,
          color: theme.palette.error.main,
        },
        standardWarning: {
          backgroundColor: theme.palette.warning[50] || theme.palette.warning.light,
          color: theme.palette.warning.main,
        },
        standardInfo: {
          backgroundColor: theme.palette.info[50] || theme.palette.info.light,
          color: theme.palette.info.main,
        },
        outlinedSuccess: {
          borderColor: theme.palette.success.main,
          color: theme.palette.success.main,
        },
        outlinedWarning: {
          borderColor: theme.palette.warning.main,
          color: theme.palette.warning.main,
        },
        outlinedError: {
          borderColor: theme.palette.error.main,
          color: theme.palette.error.main,
        },
        outlinedInfo: {
          borderColor: theme.palette.info.main,
          color: theme.palette.info.main,
        },
        successIcon: {
          color: theme.palette.info.main,
        },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        root: {
          [`& .${outlinedInputClasses.root}`]: {
            padding: '4px 9px',
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          boxShadow: 'none',
        },
        text: {
          padding: '5px 15px',
          '&:hover': {
            backgroundColor: theme.palette.primary[50] || theme.palette.primary.light,
            color: theme.palette.primary.main,
          },
        },
        textPrimary: {
          backgroundColor: theme.palette.primary[50] || theme.palette.primary.light,
          '&:hover': {
            backgroundColor: theme.palette.primary.main,
            color: 'white',
          },
        },
        textSecondary: {
          backgroundColor: theme.palette.secondary[50] || theme.palette.secondary.light,
          '&:hover': {
            backgroundColor: theme.palette.secondary.main,
            color: 'white',
          },
        },
        textSuccess: {
          backgroundColor: theme.palette.success[50] || theme.palette.success.light,
          '&:hover': {
            backgroundColor: theme.palette.success.main,
            color: 'white',
          },
        },
        textError: {
          backgroundColor: theme.palette.error[50] || theme.palette.error.light,
          '&:hover': {
            backgroundColor: theme.palette.error.main,
            color: 'white',
          },
        },
        textInfo: {
          backgroundColor: theme.palette.info[50] || theme.palette.info.light,
          '&:hover': {
            backgroundColor: theme.palette.info.main,
            color: 'white',
          },
        },
        textWarning: {
          backgroundColor: theme.palette.warning[50] || theme.palette.warning.light,
          '&:hover': {
            backgroundColor: theme.palette.warning.main,
            color: 'white',
          },
        },
        outlined: {
          backgroundColor: theme.palette.background.paper
        },
        outlinedPrimary: {
          '&:hover': {
            backgroundColor: theme.palette.primary.main,
            color: 'white',
          },
        },
        outlinedSecondary: {
          '&:hover': {
            backgroundColor: theme.palette.secondary.main,
            color: 'white',
          },
        },
        outlinedError: {
          '&:hover': {
            backgroundColor: theme.palette.error.main,
            color: 'white',
          },
        },
        outlinedSuccess: {
          '&:hover': {
            backgroundColor: theme.palette.success.main,
            color: 'white',
          },
        },
        outlinedInfo: {
          '&:hover': {
            backgroundColor: theme.palette.info.main,
            color: 'white',
          },
        },
        outlinedWarning: {
          '&:hover': {
            backgroundColor: theme.palette.warning.main,
            color: 'white',
          },
        },
      },
    },
    MuiButtonBase: {
      defaultProps: {
        disableRipple: true,
      },
    },
    MuiButtonGroup: {
      styleOverrides: {
        root: {
          boxShadow: 'none',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          width: '100%',
          padding: '15px',
          backgroundImage: 'none',
        },
      },
    },
    MuiCardContent: {
      styleOverrides: {
        root: {
          padding: '24px',
        },
      },
    },
    MuiCardHeader: {
      styleOverrides: {
        root: {
          padding: '16px 24px',
        },
        title: {
          fontSize: '1.125rem',
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          fontWeight: 600,
          fontSize: '0.75rem',
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          paddingBottom: '1.25rem',
        },
      },
    },
    MuiDialogActions: {
      styleOverrides: {
        root: {
          padding: '0 1.5rem',
        },
      },
    },
    MuiDialogContent: {
      styleOverrides: {
        root: {
          padding: '1rem 2.5rem',
        },
      },
    },
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          marginTop: '0.5rem',
          padding: '1rem 1.5rem',
          fontSize: '1.25rem',
        },
      },
    },
    MuiDivider: {
      styleOverrides: {
        root: {
          borderColor: theme.palette.divider,
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          borderColor: `${theme.palette.divider}`,
        },
      },
    },
    MuiFab: {
      styleOverrides: {
        root: {
          boxShadow: 'none',
        },
        sizeSmall: {
          width: 30,
          height: 30,
          minHeight: 30,
        },
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        asterisk: {
          color: theme.palette.error.main
        }
      }
    },
    MuiGridItem: {
      styleOverrides: {
        root: {
          paddingTop: '30px',
          paddingLeft: '30px !important',
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          '&:hover': {
            backgroundColor: theme.palette.primary.light,
            color: theme.palette.primary.main,
          },
        },
        colorPrimary: {
          '&:hover': {
            backgroundColor: theme.palette.primary.main,
            color: 'white',
          },
        },
        colorSecondary: {
          '&:hover': {
            backgroundColor: theme.palette.secondary.main,
            color: 'white',
          },
        },
        colorSuccess: {
          '&:hover': {
            backgroundColor: theme.palette.success.main,
            color: 'white',
          },
        },
        colorError: {
          '&:hover': {
            backgroundColor: theme.palette.error.main,
            color: 'white',
          },
        },
        colorWarning: {
          '&:hover': {
            backgroundColor: theme.palette.warning.main,
            color: 'white',
          },
        },
        colorInfo: {
          '&:hover': {
            backgroundColor: theme.palette.info.main,
            color: 'white',
          },
        },
      },
    },
    MuiLinearProgress: {
      styleOverrides: {
        root: {
          backgroundColor: theme.palette.grey[200],
          borderRadius: '6px',
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          backgroundColor: theme.palette.background.paper,
          [`& .${outlinedInputClasses.notchedOutline}`]: {
            borderColor:
              theme.palette.mode === 'dark' ? theme.palette.grey[200] : theme.palette.grey[300],
          },
          [`&:hover .${outlinedInputClasses.notchedOutline}`]: {
            borderColor: theme.palette.grey[300],
          },
        },
        input: {
          padding: '12px 14px',
          borderRadius: theme.shape.borderRadius,
        },
        inputSizeSmall: {
          padding: '8px 14px',
        },
        notchedOutline: ({ alt, size }) => ({
          // theme override since the styled component isn't working
          '> legend > span': { display: alt ? 'block' : 'none' }
        })
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
        },
      },
    },
    MuiPopover: {
      styleOverrides: {
        paper: {
          boxShadow: theme.shadows[9],
        },
      },
    },
    MuiStepConnector: {
      styleOverrides: {
        line: {
          borderColor: theme.palette.divider,
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          borderBottom: `1px solid ${theme.palette.divider}`,
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          '&:last-child td': {
            borderBottom: 0,
          },
        },
      },
    },
    MuiTimelineConnector: {
      styleOverrides: {
        root: {
          backgroundColor: theme.palette.divider,
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          color: theme.palette.background.paper,
          background: theme.palette.text.primary,
        },
      },
    },
  };
};
export default components;
